<template>
  <v-dialog v-model="showDialog" @click:outside="close()" scrollable max-width="300">
    <v-card>
      <v-card-title>Report</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-radio-group v-model="selection" column>
          <v-radio
            v-for="reason in reasonsToReport"
            :label="reason.description"
            :value="reason.id"
            :key="reason.id"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" text @click="close()"> Cancel </v-btn>
        <v-btn color="primary" text @click="sendReport()"> Report </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["jobId", "dialog"],
  data() {
    return {
      selection: "jobPostingExpired",
      showDialog: false,
    };
  },
  mounted() {
    if (!this.$store.state.reasonsToReport) {
      this.$store
        .dispatch("dispatchReasonsToReport")
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          console.log(this.$store.state.reasonsToReport);
        });
    }
  },
  watch: {
      dialog: function(newVal, oldVal){
          console.log(newVal);
          this.showDialog = newVal;
      }
  },
  computed: {
    reasonsToReport() {
      return this.$store.state.reasonsToReport;
    },
  },
  methods: {
    openDialog() {
      setTimeout(() => (this.dialog = true));
    },
    close(){
        this.showDialog = false;
        this.$emit('closed');
    },
    reportData() {
      return {
        [this.selection]: true,
      };
    },
    sendReport() {
      if (this.selection != null) {
        let data = { reason: "" };
        data.reason = this.selection;
        console.log(data, this.jobId);
        this.$store
          .dispatch("dispatchReport", { jobId: this.jobId, report: data })
          .then((response) => console.log(response))
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.close();
          });
      }
    },
  },
};
</script>
